import { createSlice } from "@reduxjs/toolkit";

export const snackAlertSlice = createSlice({
  name: "snackAlert",
  initialState: {
    content: "",
    open: false,
    level: "",
  },
  reducers: {
    clear: (state) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.content = "";
      state.open = false;
      state.level = "";
      state.timeout = 3000;
    },
    setTimeout: (state, action) => {
      state.content = action.payload;
    },
    setContent: (state, action) => {
      state.content = action.payload;
    },
    setOpen: (state, action) => {
      state.open = action.payload;
    },
    setLevel: (state, action) => {
      state.level = action.payload;
    },
  },
});

export const { clear, setContent, setOpen, setLevel } = snackAlertSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`
export const selectContent = (state) => state.snackAlert.content;
export const selectLevel = (state) => state.snackAlert.level;
export const selectOpen = (state) => state.snackAlert.open;

export const selectTimeout = (state) => state.snackAlert.timeout;

export default snackAlertSlice.reducer;
